
export const liveTimeStatistics = [
  { name: "5分钟以内", value: 0, percent: "0.00%" },
  { name: "5-15分钟", value: 0, percent: "0.00%" },
  { name: "15-30分钟", value: 0, percent: "0.00%" },
  { name: "30-60分钟", value: 0, percent: "0.00%" },
  { name: "60分钟以上", value: 0, percent: "0.00%" },
];


export const deviceStatistics = [
  {name: '浙政钉小程序观看人次', value: 0, percent: '0.00%'},
  {name: '浙政钉PC端观看人次', value: 0, percent: '0.00%'},
];

export const leaderTypeStatistics = [
  { name: "中管干部", value: 0, percent: "0.00%" },
  { name: "省管干部", value: 0, percent: "0.00%" },
  { name: "市管干部", value: 0, percent: "0.00%" },
  { name: "县管干部", value: 0, percent: "0.00%" },
  { name: "其他", value: 0, percent: "0.00%" },
];

export const academyStatistics = [
  { name: "杭州", value: 0, percent: "0.00%" },
  { name: "宁波", value: 0, percent: "0.00%" },
  { name: "温州", value: 0, percent: "0.00%" },
  { name: "嘉兴", value: 0, percent: "0.00%" },
  { name: "湖州", value: 0, percent: "0.00%" },
  { name: "绍兴", value: 0, percent: "0.00%" },
  { name: "金华", value: 0, percent: "0.00%" },
  { name: "衢州", value: 0, percent: "0.00%" },
  { name: "舟山", value: 0, percent: "0.00%" },
  { name: "台州", value: 0, percent: "0.00%" },
  { name: "丽水", value: 0, percent: "0.00%" },

  { name: "省院", value: 0, percent: "0.00%" },
  { name: "机关", value: 0, percent: "0.00%" },
  { name: "企业", value: 0, percent: "0.00%" },
  { name: "高校", value: 0, percent: "0.00%" },
  { name: "其他", value: 0, percent: "0.00%" },
];
